import * as React from "react";
import styled from "styled-components";
const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-151dyn0" }) `
    position: relative;
    height: 0;
    padding-top: 56.25%;

    > nav {
        opacity: 0;
        
        transition: opacity .2s;
    }

    :hover > nav {
        opacity: 1;
    }
`;
const Image = styled.img.withConfig({ displayName: "Image", componentId: "sc-1qd34m4" }) `
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
`;
const Nav = styled.nav.withConfig({ displayName: "Nav", componentId: "sc-jdc600" }) `
    display: flex;
    align-items: center;

    position: absolute;
    top: 0;
    width: 100%;
    padding: 0.5em 0.8em 3em 0.8em;
    box-sizing: border-box;

    color: white; 
    background: linear-gradient(180deg, black, transparent);
`;
const Indicator = styled.div.withConfig({ displayName: "Indicator", componentId: "sc-12h94ff" }) `
    flex: 1;
`;
const Button = styled.button.withConfig({ displayName: "Button", componentId: "sc-4v5eyv" }) `
    width: 20px;
    height: 20px;
    padding: 0;
    
    color: currentColor;
    background: transparent;
    border: none;

    cursor: pointer;

    &:last-child {
        margin-left: 0.5em;
    }

    > svg {
        width: 100%;
        height: 100%;

        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: none;
    }
`;
export const Gallery = (props) => {
    const [index, setIndex] = React.useState(0);
    const prevClick = () => {
        setIndex((index - 1 + props.items.length) % props.items.length);
    };
    const nextClick = () => {
        setIndex((index + 1) % props.items.length);
    };
    return (React.createElement(Container, null,
        React.createElement(Image, { src: props.items[index] }),
        React.createElement(Nav, null,
            React.createElement(Indicator, null,
                index + 1,
                " / ",
                props.items.length),
            React.createElement(Button, { onClick: prevClick },
                React.createElement("svg", { viewBox: "0 0 17 13" },
                    React.createElement("path", { d: "M6,1 L1,6 L6,11 M1,6 L15,6" }))),
            React.createElement(Button, { onClick: nextClick },
                React.createElement("svg", { viewBox: "0 0 17 13" },
                    React.createElement("path", { d: "M11,1 L16,6 L11,11 M16,6 L2,6" }))))));
};
